namespace SPA {
	export namespace Contacts {

		interface ISelfinfoOptions extends Backbone.ViewOptions<SPA.Contact>
		{
			asForm?: boolean;
		}

		export class SelfinfoView extends Backbone.View<SPA.Contact> {
			private asForm: boolean | undefined;

			public constructor(options: ISelfinfoOptions = {}) {
				super(options);
			}

			public preinitialize(options: ISelfinfoOptions = {}): void
			{
				// Only works if you don't pass el or remove it
				this.asForm = options.asForm || false;
				if (this.asForm)
				{
					options.tagName = 'form';
					options.className = 'contact-needs row';
				} else {
					options.tagName = 'div';
				}

				/**
				 * Listener to options model will be triggered on initialize, so be aware
				 * Better move the listener to initialize
				 */
				// this.listenTo(options.model, 'change', () => console.log('Wind of change!'));

				options.events = {
					submit: this.onQuickinfoSubmit
				};
			}

			public initialize(options?: Backbone.ViewOptions): void
			{
				// Init events
				this.listenTo(this.model, 'change:demand', this.render);
			}

			public enableSubmit()
			{
				this.asForm = true;
			}

			public render()
			{
				const demand = this.model.Demand || [];

				const employmentSelect = new ui.Form.Select(
					{
						blank: ' --- ',
						option: SPA.types.Convert.ToObjectList(SPA.types.Contact.Employment),
						name: 'demand.quick.employment',
						control: true,
					}, demand && demand.quick ? demand.quick.employment : undefined
				);
				employmentSelect.Initialize();

				const civilStatusSelect = new ui.Form.Select(
					{
						blank: ' --- ',
						option: SPA.types.Convert.ToObjectList(SPA.types.Contact.CivilStatus),
						name: 'demand.quick.civilstatus',
						control: true,
					}, demand && demand.quick ? demand.quick.civilstatus : undefined
				);
				civilStatusSelect.Initialize();

				const childrenSelect = new ui.Form.Select(
					{
						option: {0: "keine", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", 10: "10"},
						name: 'demand.quick.children_count',
						control: true,
					}, demand && demand.quick ? demand.quick.children_count : undefined
				);
				childrenSelect.Initialize();

				const html =
					ui.$$.div().addClass('col-xs-12')
						.append('<h2>Selbstauskunft</h2>')
					.add(ui.$$.div().addClass('col-xs-4 form-group')
						.append(ui.$$.label().addClass('control-label').text('Beschäftigungsverhältnis'))
						.append(employmentSelect.Input())
					)
					.add(ui.$$.div().addClass('col-xs-4 form-group')
						.append(ui.$$.label().addClass('control-label').text('Haushaltsnettoeinkommen pro Monat'))
						.append(
							$('<div class="input-group">')
								.append(ui.$$.input().addClass('form-control currency').attr({name: 'demand.quick.household_netincome', value: demand && demand.quick ? demand.quick.household_netincome : ''}))
								.append('<div class="input-group-addon"><span>€</span></div>')
						)
					)
					.add(ui.$$.div().addClass('col-xs-4 form-group')
						.append(ui.$$.label().addClass('control-label').text('Eigenkapital'))
						.append(
							$('<div class="input-group">')
								.append(ui.$$.input().addClass('form-control currency').attr({name: 'demand.quick.equity', value: demand && demand.quick ? demand.quick.equity : ''}))
								.append('<div class="input-group-addon"><span>€</span></div>')
							)
					)
					.add(ui.$$.div().addClass('clearfix'))
					.add(ui.$$.div().addClass('col-xs-6 form-group')
						.append(ui.$$.label().addClass('control-label').text('Familienstand'))
						.append(civilStatusSelect.Input())
					)
					.add(ui.$$.div().addClass('col-xs-3 form-group')
						.append(ui.$$.label().addClass('control-label').text('Anzahl Kinder'))
						.append(childrenSelect.Input())
					);
				this.$el.empty().append(html);

				if (this.asForm) {
					const btnSaveSelfInfo = ui.$$.button()
						.addClass('btn btn-success btn-save btn-save-top')
						.append('<i class="fas fa-save"></i><span> Selbstauskunft speichern</span>');

					this.$el.append(ui.$$.div().addClass('col-xs-12').append(btnSaveSelfInfo));
				}

				return this;
			}

			private onQuickinfoSubmit(e: JQuery.TriggeredEvent) {
				e.preventDefault();
				const formElements = (e.currentTarget as HTMLFormElement).elements;
				const obj = {};
				for (const entry of formElements) {
					if (entry.name === '') {
						continue;
					}
					entry.name = entry.name.replace('demand.', '');

					let entryValue = entry.value;
					if ($(entry).hasClass('number') || $(entry).hasClass('currency'))
					{
						entryValue = accounting.unformat(entry.value, ',').toString();
					}

					const parts = entry.name.split('.');

					let subObj: any = obj;
					while (parts.length > 1) {
						const part = parts.shift();
						if (subObj[part] === undefined) {
							subObj[part] = {};
						}

						subObj = subObj[part];
					}
					const prop = parts[0];
					if (subObj[prop] === undefined) {
						subObj[prop] = entryValue;
					} else {
						if (!(subObj[prop] instanceof Array)) {
							subObj[prop] = [subObj[prop]];
						}
						subObj[prop].push(entryValue);
					}
				}

				app.getContactManager().saveDemand(this.model.ContactID, obj);
			}
		}
	}
}